import Vue from 'vue'
import Vue2Filters from 'vue2-filters'
import VueMoment from 'vue-moment'
const moment = require('moment')
import 'moment/locale/ru'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import './plugins/axios'

import VueMask from 'v-mask'

Vue.use(Vue2Filters)
Vue.use(VueMoment, {moment})
Vue.use(VueMask)

Vue.config.productionTip = false

new Vue({
    router,
    store,
    vuetify,
    render: h => h(App),

    mounted () {
        this.$moment.locale('ru')
    },

    created () {
        this.$axios.defaults.baseURL = process.env.VUE_APP_API_ENDPOINT;

        const authToken = localStorage.getItem('auth-token')

        if (authToken) {
            this.$axios.defaults.headers.common['Authorization'] = authToken
        }

        const self = this

        this.$axios.defaults.withCredentials = true

        this.$axios.interceptors.response.use(
            function (res) {
                if (res.headers['x-user-id'] && self.$store.getters.user) {
                    self.$store.commit('updateUserID', res.headers['x-user-id'])
                }

                if (res.headers['x-user-manager'] && self.$store.getters.user) {
                    self.$store.commit('updateUserManager', res.headers['x-user-manager'])
                }

                if (res.headers['x-user-root'] && self.$store.getters.user) {
                    self.$store.commit('updateUserRoot', res.headers['x-user-root'])
                }

                if (res.headers['x-user-task'] && self.$store.getters.user) {
                    self.$store.commit('updateUserTask', res.headers['x-user-task'])
                }

                if (res.headers['x-user-task-schedule'] && self.$store.getters.user) {
                    self.$store.commit('updateUserTaskSchedule', res.headers['x-user-task-schedule'])
                }

                if (res.headers['x-user-marketing-task'] && self.$store.getters.user) {
                    self.$store.commit('updateUserMarketingTask', res.headers['x-user-marketing-task'])
                }

                if (res.headers['x-user-marketing-task-schedule'] && self.$store.getters.user) {
                    self.$store.commit('updateUserMarketingTaskSchedule', res.headers['x-user-marketing-task-schedule'])
                }

                return Promise.resolve(res)
            },
            function (error) {
                if (error.response.status === 401 || error.response.status === 403) {
                    self.$store.commit('removeToken')
                    self.$store.commit('removeUser')
                    self.$router.push('/sign-in')
                    // return Promise.reject(error)
                }
            }
        )
    }
}).$mount('#app')
